const lawOrder = [
    'Advance Notice',
    'Pre-marking (\'Whitelining\')',
    'Notice: Excavation',
    'Notice: Blasting',
    'Notice: Demolition',
    'Notice: Design/Survey',
    'Notice: Agricultural',
    'Notice: Large Projects',
    'Notice: Roads',
    'Notice: Other',
    'Notification: Damage',
    'Notification: Emergency',
    'Notification: Ticket Cancellation',
    'Information Required',
    'Ticket Size',
    'Wait Time',
    'Time Calculation',
    'Ticket Life',
    'Official Holidays',
    'Training',
    'Meeting Request',
    'Agreements',
    'Locating',
    'Marking',
    'Accuracy of Markings',
    'Color and Marking Codes',
    'Trouble Locate',
    'Operator Response: Damage',
    'Operator Response: Design/Survey',
    'Operator Response: Emergency',
    'Operator Response: XXXXX',
    'Operator Response: Extraordinary Circumstance',
    'Positive Response',
    'Make a 2nd Call When…',
    'Operator Presence During Excavation',
    'Tolerance Zone',
    'Safety Zone Limitations',
    'Tolerance Zone Activity Limitations',
    'Protecting Marks',
    'Excavator Responsibilities While Digging',
    'Excavation Near Certain Facilities',
    'Abandoned Facility',
    'Trenchless Excavation',
    'Complex or Large Projects',
    'Design Disclosure',
    'Special Provisions: One Call Center',
    'Special Provisions: Excavator',
    'Special Provisions: Operator',
    'Special Provisions: Other',
    'During an Emergency that Requires Excavation',
    'When Damage Occurs',
    'Reporting',
    'Enforcement Agency',
    'Fines and Penalties',
    '811 Notification Center',
    'Facilities not required to be in One Call System',
    'Activities That Do Not Require a One Call',
    'Glossary of Terms'
  ];
  
  export { lawOrder };
  


// WEBPACK FOOTER //
// ./src/components/pages/stateLaw/assets/lawOrder.js